import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectCampaigns } from "../features/campaignSlice";
import CampaignForm from "../features/CampaignForm";
import CampaignTable from "../features/CampaignTable";
import "./campaign.css";
import Modal from "./Modal";

function Campaign() {
  const campaigns = useSelector(selectCampaigns);

  const [openModal, setOpenModal] = useState(false);
  const onHandleClick = () => {
    setOpenModal(true);
  };
  const onHandleClose = () => {
    setOpenModal(false);
  };

  return (
    <>
          <section className="header">
            <h1 className="">Campaign Dashboard</h1>
            <button
              onClick={onHandleClick}
              className="button bg-[#c95128] text-white  px-6 py-3 "
            >
              <i className="fas fa-download mr-2"></i> + Add Campaign
            </button>
          </section>
          <CampaignTable campaigns={campaigns} />
          {openModal && (
            <Modal onClose={onHandleClose}>
              <CampaignForm onHandleClose={onHandleClose} />
            </Modal>
      )}
    </>
  );
}

export default Campaign;
